import { render, staticRenderFns } from "./v-know.vue?vue&type=template&id=6072cdc4&"
import script from "./v-know.vue?vue&type=script&lang=js&"
export * from "./v-know.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports